export const callColorPallet = ['#6B3FFE', '#1E90FF', '#0000CD', '#00BFFF', '#4988C6', '#16B4B4', '#00FFFF', '#32CD32', '#50C878', '#40E0D0']
export const putColorPallet = ['#FFA719', '#FFA047', '#D8D000', '#FF6347', '#FF4500', '#DC143C', '#FF5722', '#FF0000', '#FF1493', '#FF69B4']
export const callColorCumulative = '#2F2FCD'
export const putColorCumulative = '#FFA719'
export const primarySecColorLightTheme = '#3a3a3a3b'
export const primarySecColorDarkTheme = '#e0e0e03b'